import ReactPaginate from "react-paginate";
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

function OrganizationTable({
    organizations = [],
    getOrganizations,
    deleteOrganization,
    totalPages,
    setPage,
    page,
    isSearched,
    setIsSearched,
    itemsPerPage,
    setItemsPerPage,
    hasSearched,
    resetSearch,
    totalOrganizations,
    setSelectedOrganizacion
}) {

    const { search, option, state } = isSearched;

    // -------------------------

    const handlePageClick = (data) => {
        state
            ? getOrganizations({ page: data.selected + 1, [option]: search })
            : getOrganizations({ page: data.selected + 1 });
    };

    const resetOrganizaciones = async () => {
        setIsSearched({
            search: "",
            option: "",
            state: false
        });

        setPage(1);
        getOrganizations({});
        resetSearch();
    };

    const onItemsPerPageChange = (e) => {
        const limit = e.target.value;

        setItemsPerPage(limit);

        state
            ? getOrganizations({ page: 1, limit, [option]: search })
            : getOrganizations({ page: 1, limit });
    };

    // -------------------------

    const renderRegions = (regions) => {

        if (!regions?.length) return "-";

        const REGION_NAMES = {
            CO03: "Oriente",
            CO04: "Occidente",
            CO05: "Costa"
        };

        return regions
            .map(code => REGION_NAMES[code])
            .join(" | ");
    };

    // -------------------------

    const renderTypeSale = (typeSale) => {

        if (!typeSale) return "-";

        const labels = [];

        if (typeSale.tangible) {
            labels.push("Tangible");
        }

        if (typeSale.intangible) {
            let text = "Intangible";

            const recargas = [];

            if (typeSale.recargaPasatiempo) {
                recargas.push("Pasatiempo");
            }

            if (typeSale.recargaEnLineaPQ) {
                recargas.push("En Línea PQ");
            }

            if (recargas.length) {
                text += ` (${recargas.join(", ")})`;
            }

            labels.push(text);
        }

        return labels.join(" | ");
    };

    // -------------------------

    return (
        <div className="mt-4">

            {/* HEADER */}
            <div className="row mb-2">

                <div className="col d-flex align-items-end">
                    <h6>Organizaciones registradas</h6>
                </div>

                <div className="col d-flex justify-content-end">

                    <div className="d-flex flex-row gap-3">

                        {/* ITEMS PER PAGE */}
                        <div className="d-flex flex-row align-items-center gap-2">

                            <label className="mb-0">
                                Mostrar:
                            </label>

                            <select
                                onChange={onItemsPerPageChange}
                                className="form-select form-select-sm"
                                style={{ width: "80px" }}
                                value={itemsPerPage}
                            >
                                {
                                    ITEMS_BY_PAGE_OPTIONS.map((value, index, arr) => {
                                        if (totalOrganizations <= arr?.[index - 1]) return null;

                                        return (
                                            <option
                                                value={value}
                                                key={value}
                                            >
                                                {value}
                                            </option>
                                        );
                                    })
                                }
                            </select>
                        </div>

                        <button
                            className="btn btn-primary"
                            onClick={resetOrganizaciones}
                            disabled={!hasSearched}
                        >
                            Limpiar búsqueda
                        </button>

                    </div>

                </div>
            </div>

            {/* TABLE */}
            <div
                className="table-responsive rounded-3"
                style={{ border: "1px solid black" }}
            >

                <table className="table">

                    <thead>
                        <tr>
                            <th>#</th>
                            <th>NIT</th>
                            <th>KUNNR</th>
                            <th>Razón Social</th>
                            <th>Dirección</th>
                            <th>Tipo de Venta</th>
                            <th>Regiones</th>
                            <th className="text-center">Acción</th>
                        </tr>
                    </thead>

                    <tbody>

                        {
                            organizations.length
                                ? organizations.map((org, i) => (

                                    <tr key={org._id}>

                                        <td>{i + 1}</td>
                                        <td>{org.nit}</td>
                                        <td>{org.kunnr}</td>
                                        <td>{org.razonSocial}</td>
                                        <td>{org.direccion}</td>
                                        <td>{renderTypeSale(org.typeSale)}</td>
                                        <td>{renderRegions(org.regions)}</td>


                                        <td className="text-center">

                                            <div className="d-flex gap-2 justify-content-center">

                                                <button
                                                    className="btn btn-sm btn-warning"
                                                    onClick={() => setSelectedOrganizacion(org)}
                                                >
                                                    Editar
                                                </button>

                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => deleteOrganization(org._id)}
                                                >
                                                    Eliminar
                                                </button>

                                            </div>

                                        </td>

                                    </tr>
                                ))
                                :
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        Sin datos
                                    </td>
                                </tr>
                        }

                    </tbody>
                </table>

            </div>

            {/* PAGINATION */}

            <ReactPaginate
                previousLabel={"Anterior"}
                nextLabel={"Siguiente"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                forcePage={page - 1}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center mt-3"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
            />

        </div>
    );
}

export default OrganizationTable;
